











































































import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { FindProdutoUseCase } from '@/usecases';
import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';

@Component({
	components: {
	},
})

export default class DialogoDeUploadDeArquivoParaBuscaDeProdutos extends Vue {
	findProdutoUseCase = new FindProdutoUseCase()

	mostra = false;
	identificacaoDoProdutoErro = '';
	isReferenciaPai: boolean | null = null;
	arquivo: File[] = [];
	arquivoContemCabecalho = false
	carregando = false

	mostrar(){
		this.mostra = true
	}

	esconder(){
		this.mostra = false
		this.isReferenciaPai = null
		this.identificacaoDoProdutoErro = ''
		this.arquivo=[]
		this.arquivoContemCabecalho = false
		this.carregando = false
	}

	async buscar(){

		try{
			if(this.arquivo.length <= 0){
				AlertModule.setError('Necessario anexar um arquivo para a busca')
				return
			}

			if (this.isReferenciaPai === null) {
				this.identificacaoDoProdutoErro = 'Selecione o tipo do identificador do produto.'
				return
			} else {
				this.identificacaoDoProdutoErro = ''
			}

			this.carregando = true

			const pattern = /[~`!@#$%^&*()áÁàÀçÇõÕãÃôÔêÊ\-+={}[\]|\\;:'",<>/?]+/g;
			const espaco = /\s+/g;

			if (this.arquivo.length > 0 && (pattern.test(this.arquivo[0].name) || espaco.test(this.arquivo[0].name))) {
				const anexo = this.arquivo[0];
				let url = anexo.name.replace(espaco, '_');
				
				url = url.replace(pattern, '');
				
				const anexoFormatado = new File([anexo], url, {
					type: anexo.type,
					lastModified: anexo.lastModified,
				});
				this.arquivo[0] = anexoFormatado;
			}

			const skuOrEanDosProdutos = await this.findProdutoUseCase.findProdutoByCsv(
				this.arquivo[0],
				this.isReferenciaPai !== null ? this.isReferenciaPai : false,
				this.arquivoContemCabecalho,
			)

			if(Array.isArray(skuOrEanDosProdutos) && skuOrEanDosProdutos.length === 0){
				AlertModule.setError('Nenhum produto foi encontrado.')
				this.carregando = false
				return
			}

			this.$emit('skuOrEanDosProdutos', skuOrEanDosProdutos);
			this.esconder()
		} catch(e){
			if (axios.isCancel(e)) return
			AlertModule.setError(e)
			this.carregando = false
		}
	}
	
	async baixarModeloDeCsv() {
		const rows = [
			[
				'identificacaoDoProduto',
			],
		]

		const csvContent = "data:text/csv;charset=utf-8," 
			+ rows.map(e => e.join(";")).join("\n")

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement("a")
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", "modelo_busca_de_produtos_por_sku_ou_ean.csv")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}
}
